import React, {PropTypes} from 'react';
import StatusItem from './StatusItem.jsx';
import Submitting from 'shared/Submitting.jsx';
import DisplayIf from 'shared/DisplayIf.jsx';
import ConfirmStatusChangeModalContainer from './ConfirmStatusChangeModalContainer.jsx';
import ErrorListContainer from 'shared/error/ErrorListContainer.jsx';

const Status = ({
  currentStatus,
  statuses,
  publishing,
  hasPendingChanges,
  onPublishClick,
  onSetStatusClick,
  exportSystemName,
  systemShouldExport,
  onExportClick,
  loading,
  exportStatus,
  onDownloadExportClick
}) => (
  <div className="flex center animated fadeIn">
    <div className="col-xs-12 col-lg-10">
      <ErrorListContainer />
      <DisplayIf condition={!loading && hasPendingChanges && !systemShouldExport}>
        <div className="alert alert-warning flex space-between">
          <p className="flex-2">{'We have detected pending changes in this tournament\'s configuration. Please check with the tournament manager before proceeding.'}</p>
          <button type="button"
            className="btn btn-warning flex-1"
            disabled={publishing}
            onClick={onPublishClick}>
            {publishing
              ? <span><Submitting /> {'Publishing'}</span>
              : 'I understand. Push to TMS'
            }
          </button>
        </div>
      </DisplayIf>
      <DisplayIf condition={!loading && systemShouldExport}>                    
          { /* Export has not been initiated = 0 or null */ }
          <DisplayIf condition={exportStatus == null || exportStatus == 0}>
            <div className="alert alert-warning flex space-between">
              <p className="flex-3">{currentStatus !== statuses[3] && currentStatus !== statuses[4] ?
                'Exporting is disabled unless tournament status is set to "Public Registration Closed" or "All Registrations Closed."'
              : 'Please check with the tournament manager before proceeding.'}</p>
              <p className="flex-1" />
              <button type="button"
                className="btn btn-success flex-1"
                disabled={publishing || (currentStatus !== statuses[3] && currentStatus !== statuses[4])}
                onClick={onExportClick}>
                {publishing
                  ? <span><Submitting /> {'Exporting'}</span>
                  : `Export File for ${exportSystemName}`
                }
              </button>
            </div>
          </DisplayIf>
          { /* Export is Running = 1 */ }
          <DisplayIf condition={exportStatus == 1}>
            <div className="alert alert-warning flex space-between">
              <p className="flex-3">
                {'We are in the process of exporting this tournament. Feel free to leave this page and come back, or refresh this page, to check the status of your export.'}
              </p>
            </div>
          </DisplayIf>
          { /* Export is Completed = 2 */ }
          <DisplayIf condition={exportStatus == 2}>
            <div className="alert alert-warning flex space-between">
              <p className="flex-3">
                {'We have completed exporting this tournament. Please click the button to download the import file.'}</p>
              <p className="flex-1" />
              <button type="button"
                className="btn btn-success flex-1"
                onClick={onDownloadExportClick}>
                {<span>{'Download Import File'}</span>}
              </button>
            </div>
          </DisplayIf>
          { /* Export has Failed = 3 */ }
          <DisplayIf condition={exportStatus == 3}>
            <div className="alert alert-danger flex space-between">
              <p className="flex-3">
              {'We encountered an error exporting this tournament. Please contact your Registration support.'}
              </p>
              <p className="flex-1" />
              <button type="button"
                className="btn btn-success flex-1"
                disabled={publishing || (currentStatus !== statuses[3] && currentStatus !== statuses[4])}
                onClick={onExportClick}>
                {publishing
                  ? <span><Submitting /> {'Exporting'}</span>
                  : `Export File for ${exportSystemName}`
                }
              </button>
            </div>
          </DisplayIf>      
      </DisplayIf>
      <div className="list-group">
        {statuses.map((status, index) => (
          <StatusItem key={index}
            status={status}
            active={currentStatus === status}
            onSetStatusClick={onSetStatusClick}
            hasPendingChanges={systemShouldExport ? false : hasPendingChanges}
          />
        ))}
      </div>
    </div>
    <ConfirmStatusChangeModalContainer />
  </div>
);

Status.propTypes = {
  currentStatus: PropTypes.string,
  statuses: PropTypes.arrayOf(PropTypes.string),
  publishing: PropTypes.bool,
  hasPendingChanges: PropTypes.bool,
  onPublishClick: PropTypes.func,
  onSetStatusClick: PropTypes.func,
  exportSystemName: PropTypes.string,
  systemShouldExport: PropTypes.bool,
  onExportClick: PropTypes.func,
  loading: PropTypes.bool,
  exportStatus: PropTypes.number,
  onDownloadExportClick: PropTypes.func
};

Status.defaultProps = {
  currentStatus: '',
  statuses: [],
  publishing: false,
  hasPendingChanges: false,
  exportSystemName: '',
  systemShouldExport: false,
  loading: false
};

export default Status;



// WEBPACK FOOTER //
// ./src/features/tournament/status/Status.jsx